<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetVolume" });
import { Heading } from "../../../../../typography/index.js";
import { InputRadio } from "../../../../../selects/index.js";
import { InputMonetary } from "../../../../../inputs/index.js";
import SelectQuantity from "../../select-quantity/SelectQuantity.svelte";
export let subscription;
const DOMAIN = import.meta.env.VITE_DOMAIN;
const getVolumeOption = () => {
    if (subscription.constraints?.minimum?.value !== void 0) {
        subscription.constraints.minimum.quantityCode = void 0;
        return "value";
    }
    if (subscription.constraints?.minimum?.quantityCode !== void 0) {
        subscription.constraints.minimum.value = void 0;
        return "quantity";
    }
    return "value";
};
let option = getVolumeOption();
const onOptionChange = (option2) => {
    if (subscription.constraints?.minimum === void 0) {
        return;
    }
    if (option2 === "value") {
        subscription.constraints.minimum.quantityCode = void 0;
        return;
    }
    subscription.constraints.minimum.value = void 0;
};
$: onOptionChange(option);
</script>

{#if subscription.constraints?.minimum !== undefined}
    <div class = 's8-step-container'>
        <Heading size='xs'>{ `How much do ${ DOMAIN === 'internal' ? 'they' : 'you' } need?` }</Heading>

        <div class = 's8-options'>
            <div>
                <InputRadio
                    bind:key = { option }
                    name = 'amount-selection'
                    value = 'value'
                    label = 'Minimum RRP'
                />
                <InputMonetary
                    bind:value = { subscription.constraints.minimum.value }
                    bind:currencyCode = { subscription.currencyCode }
                    name = 'subscription.minimum'
                    minimum = { 0 }
                    placeholder = { DOMAIN === 'internal'
                        ? 'E.g. 50,000'
                        : 'Your minimum desired RRP value, e.g. 50,000 EUR' }
                    isDisabled = { option !== 'value' }
                    isRequired = { false }
                />
            </div>

            <div>
                <InputRadio
                    bind:key = { option }
                    name = 'amount-selection'
                    value = 'quantity'
                    label = 'Minimum Quantity'
                />
                <SelectQuantity
                    bind:key = { subscription.constraints.minimum.quantityCode }
                    name = 'subscription.quantity'
                    placeholder = { DOMAIN === 'internal'
                        ? 'E.g. more than 500 items'
                        : 'Select a range for your desired item count, e.g. more than 500 items' }
                    label = { null }
                    isDisabled = { option !== 'quantity' }
                />
            </div>
        </div>

    </div>
{/if}

<style>
    div.s8-step-container {
        margin-bottom: 15px;
    }

    div.s8-options {
        display: grid;
        -moz-column-gap: 40px;
             column-gap: 40px;
        grid-template-columns: repeat(2, 1fr);
        position: relative;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    @media (max-width: 780px) {
        div.s8-options {
            display: flex;
            flex-direction: column;
        }
    }</style>